import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'

import { BuildingInterface, setByFlag } from '@store/actionSlices/building'
import { selectThreeDView } from '@store/actionSlices/threeDView'
import { RouteKey } from '@store/constants'

import {
  EnvisionVRConfigurationInterface,
  SnaploaderConfigurationInterface,
} from '@api/config'

import { hasEnvisionVR, hasSnaploader } from '@utilities/helper'

import { ArrowSvg } from '@svg/react'

import { useCompareProperty } from '@adUtilities/components/compare-property/utils'

interface ComponentProps {
  building: BuildingInterface
  snaploaderConfiguration: SnaploaderConfigurationInterface
  envisionVRConfiguration: EnvisionVRConfigurationInterface
  hasThreeDViewer?: boolean
  comparePropertyProps: ReturnType<typeof useCompareProperty>
  isShowcase3dEnabled: boolean
}

function BackButton({
  building,
  snaploaderConfiguration,
  envisionVRConfiguration,
  hasThreeDViewer,
  comparePropertyProps,
  isShowcase3dEnabled,
}: ComponentProps) {
  const dispatch = useDispatch()
  const history = useHistory()
  const { selectedLevelId } = useSelector(selectThreeDView)

  const isReturningToThreeDLevel = isShowcase3dEnabled && !!selectedLevelId

  const handleBackNav = () => {
    if (comparePropertyProps.compareModeIsActive) {
      comparePropertyProps.stopComparison()
      dispatch(setByFlag({ flag: 'activeUnit', value: '' }))
      setByFlag({ flag: 'activeLevel', value: building.levels[0].level })
      return
    }
    if (building.activeUnit) {
      dispatch(setByFlag({ flag: 'activeUnit', value: '' }))
      if (!isReturningToThreeDLevel) {
        return
      }
    }
    if (building.activeLevel) {
      dispatch(
        setByFlag({ flag: 'activeLevel', value: building.levels[0].level })
      )

      if (isShowcase3dEnabled) {
        history.push(RouteKey.ADTHREED, { isBackBtnNavigation: true })
        return
      }

      if (hasSnaploader(snaploaderConfiguration)) {
        history.push(RouteKey.SNAPLOADER_VIEW)
        return
      }
      if (hasEnvisionVR(envisionVRConfiguration)) {
        history.push(RouteKey.THREE_D_BUILDING)
        return
      }
      if (hasThreeDViewer) {
        history.push(RouteKey.AREA_VIEW_3D)
        return
      }
      history.push(RouteKey.LEVEL_VIEW)
    }
  }

  return (
    <button
      className="rounded-full border border-zinc-400 p-1"
      type="button"
      onClick={() => handleBackNav()}
    >
      <ArrowSvg className="h-6 w-6 stroke-zinc-400" rotate="left" />
    </button>
  )
}

export default BackButton
